import images from "./images";

const testimonials = [
    {
        id: 1,
        image: images.testimonial1,
        name: 'John Doe',
        title: 'Homeowner',
        rating: 5,
        content: 'Fenestra\'s team provided excellent service! Their attention to detail and quality craftsmanship exceeded my expectations.',
    },
    {
        id: 2,
        image: images.testimonial2,
        name: 'Jane Smith',
        title: 'Homeowner',
        rating: 5,
        content: 'I am extremely satisfied with the windows and doors installed by Fenestra. The whole process was seamless and hassle-free.',
    },
    {
        id: 3,
        image: images.testimonial3,
        name: 'Michael Thompson',
        title: 'Builder',
        rating: 5,
        content: 'The team at Fenestra is professional and knowledgeable. I highly recommend their services to anyone looking for quality windows and doors.',
    },
    {
        id: 4,
        image: images.testimonial4,
        name: 'Emily Johnson',
        title: 'Architect',
        rating: 5,
        content: 'Fenestra\'s commitment to quality and customer satisfaction is commendable. I am delighted with the results!',
    },
];

export default testimonials;